// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tuT1K","content":"styles_content__Y72mz","tableWrap":"styles_tableWrap__2fM8N"};